import React from 'react';
import { Route, Switch } from 'react-router-dom';
import RouteWithSubRoutes from '../RouterWithSubRoutes';
import ScrollToTop from '../ScrollTop';
import NotFound from '../../page/NotFound';

const RenderRoutes = (props) => {
  const { routes } = props;

  return (
    <>
      <Switch>
        {routes.map((route) => {
          const { key } = route;
          return <RouteWithSubRoutes key={key} {...route} />;
        })}
        <Route component={() => <NotFound />} />
      </Switch>
      <ScrollToTop />
    </>
  );
};

export default RenderRoutes;
